// Requires: src/namespace.js

window.BOL.RegisterProduct.sectionManager = (function($) {
	'use strict';

	var DATA_ATTRIBUTES = {
		stage:       	'data-stage',
		stageHidden: 	'data-stage-hidden',
		promoInput:  	'data-promofields-code',
		promoButton:  'data-promofields-button'
	};

	var SECTIONS = {
		form:          1,
		gifScreen:     2,
		loading:       3,
		results:       4,
		success:       5,
		productDetail: 6,
		continueButton:7
	};

	var $promoInput         	= $('[' + DATA_ATTRIBUTES.promoInput + ']');
	var $promoButton         	= $('[' + DATA_ATTRIBUTES.promoButton + ']');

	var $sections = {};

	// Make sure promo input is disabled until date is added (external function)
	function disablePromo(productPage) {
		if (productPage === 6) {
			$promoInput.attr('disabled', 'disabled');
			$promoButton.attr('disabled', 'disabled');
		}
	}

	function showSection(id) {
		$sections[id].attr(DATA_ATTRIBUTES.stageHidden, false);
		disablePromo(id);		
	}

	function hideSection(id) {
		$sections[id].attr(DATA_ATTRIBUTES.stageHidden, true);
	}

	function populateStages() {
		var stageName;
		for(stageName in SECTIONS) {
			$sections[SECTIONS[stageName]] = $('[' + DATA_ATTRIBUTES.stage + '="' + SECTIONS[stageName] + '"]');
		}
	}

	function reset(showContinue, hideContinue) {
		/*
		showContinue sets to show the continue to step 2 button on the first stage (shows if adding another product)
		hideContinue sets to hide the contrinue to step 2 button on the first stage (if all products are removed)

		if neither showContinue nor hideContinue are true then the state of the button is left as it was before the reset
		*/
		hideSection(SECTIONS.productDetail);
		hideSection(SECTIONS.loading);
		hideSection(SECTIONS.success);
		hideSection(SECTIONS.results);
		showSection(SECTIONS.form);
		showSection(SECTIONS.gifScreen);

		if (showContinue) {
			showSection(SECTIONS.continueButton);
		} else if (hideContinue) {
			hideSection(SECTIONS.continueButton);
		}

		$('[data-datefield-date]').val('');
		$('[data-promofields-code]').val('');
	}

	return {
		SECTIONS:       SECTIONS,
		showSection:    showSection,
		hideSection:    hideSection,
		reset:          reset,
		populateStages: populateStages
	};

})($jq);
